// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"255b050c","807":"f02734f9","935":"b44f7fec"}[chunkId] + ".chunk.js";
};